export const CODE_MAX_LENGTH = 40;
export const NAME_MAX_LENGTH = 255;
export const DESCRIPTION_MAX_LENGTH = 2000;
export const KEY_MAX_LENGTH = 255;
export const SQL_MAX_LENGTH = 30000;
